var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centralizado bg-cubo"},[_c('div',{staticClass:"cubo"},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span')]),_c('div',{staticClass:"loading"},[_c('div',{},[_c('h1',[_vm._v("Cargando. . .")])])])])
}]

export { render, staticRenderFns }